/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiV1ReferralPopupsParams,
  GetReferralPopupByPartnerKeyResponse,
  GetReferralPopupsResponse,
  HttpValidationProblemDetails,
  PatchReferralPopupRequestBody,
  PostReferralPopupRequestBody,
  ProblemDetails,
  ReferralPopupDetails
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiV1ReferralPopups = (
    postReferralPopupRequestBodyNull: PostReferralPopupRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<ReferralPopupDetails | null>(
      {url: `/api/v1/referral-popups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postReferralPopupRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1ReferralPopupsMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ReferralPopups>>, TError,{data: PostReferralPopupRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ReferralPopups>>, TError,{data: PostReferralPopupRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1ReferralPopups'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ReferralPopups>>, {data: PostReferralPopupRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1ReferralPopups(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ReferralPopupsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ReferralPopups>>>
    export type PostApiV1ReferralPopupsMutationBody = PostReferralPopupRequestBody | null
    export type PostApiV1ReferralPopupsMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePostApiV1ReferralPopups = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ReferralPopups>>, TError,{data: PostReferralPopupRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ReferralPopups>>,
        TError,
        {data: PostReferralPopupRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1ReferralPopupsMutationOptions(options), queryClient);
    }
    export const getApiV1ReferralPopups = (
    params?: GetApiV1ReferralPopupsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetReferralPopupsResponse | null>(
      {url: `/api/v1/referral-popups`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1ReferralPopupsQueryKey = (params?: GetApiV1ReferralPopupsParams,) => {
    return [
    `/api/v1/referral-popups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1ReferralPopupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError = HttpValidationProblemDetails | null>(params?: GetApiV1ReferralPopupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ReferralPopupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ReferralPopups>>> = ({ signal }) => getApiV1ReferralPopups(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ReferralPopupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ReferralPopups>>>
export type GetApiV1ReferralPopupsQueryError = HttpValidationProblemDetails | null


export function useGetApiV1ReferralPopups<TData = Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError = HttpValidationProblemDetails | null>(
 params: undefined |  GetApiV1ReferralPopupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ReferralPopups>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ReferralPopups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ReferralPopups<TData = Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError = HttpValidationProblemDetails | null>(
 params?: GetApiV1ReferralPopupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ReferralPopups>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ReferralPopups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ReferralPopups<TData = Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError = HttpValidationProblemDetails | null>(
 params?: GetApiV1ReferralPopupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ReferralPopups<TData = Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError = HttpValidationProblemDetails | null>(
 params?: GetApiV1ReferralPopupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ReferralPopupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiV1ReferralPopupsPartnerKey = (
    partnerKey: string | null,
    patchReferralPopupRequestBodyNull: PatchReferralPopupRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<ReferralPopupDetails | null>(
      {url: `/api/v1/referral-popups/${partnerKey}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchReferralPopupRequestBodyNull, signal
    },
      );
    }




export const getPatchApiV1ReferralPopupsPartnerKeyMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ReferralPopupsPartnerKey>>, TError,{partnerKey: string | null;data: PatchReferralPopupRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ReferralPopupsPartnerKey>>, TError,{partnerKey: string | null;data: PatchReferralPopupRequestBody | null}, TContext> => {

const mutationKey = ['patchApiV1ReferralPopupsPartnerKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1ReferralPopupsPartnerKey>>, {partnerKey: string | null;data: PatchReferralPopupRequestBody | null}> = (props) => {
          const {partnerKey,data} = props ?? {};

          return  patchApiV1ReferralPopupsPartnerKey(partnerKey,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1ReferralPopupsPartnerKeyMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ReferralPopupsPartnerKey>>>
    export type PatchApiV1ReferralPopupsPartnerKeyMutationBody = PatchReferralPopupRequestBody | null
    export type PatchApiV1ReferralPopupsPartnerKeyMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePatchApiV1ReferralPopupsPartnerKey = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1ReferralPopupsPartnerKey>>, TError,{partnerKey: string | null;data: PatchReferralPopupRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1ReferralPopupsPartnerKey>>,
        TError,
        {partnerKey: string | null;data: PatchReferralPopupRequestBody | null},
        TContext
      > => {
      return useMutation(getPatchApiV1ReferralPopupsPartnerKeyMutationOptions(options), queryClient);
    }
    export const deleteApiV1ReferralPopupsPartnerKey = (
    partnerKey: string | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/referral-popups/${partnerKey}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1ReferralPopupsPartnerKeyMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1ReferralPopupsPartnerKey>>, TError,{partnerKey: string | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1ReferralPopupsPartnerKey>>, TError,{partnerKey: string | null}, TContext> => {

const mutationKey = ['deleteApiV1ReferralPopupsPartnerKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1ReferralPopupsPartnerKey>>, {partnerKey: string | null}> = (props) => {
          const {partnerKey} = props ?? {};

          return  deleteApiV1ReferralPopupsPartnerKey(partnerKey,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1ReferralPopupsPartnerKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ReferralPopupsPartnerKey>>>

    export type DeleteApiV1ReferralPopupsPartnerKeyMutationError = ProblemDetails | null

    export const useDeleteApiV1ReferralPopupsPartnerKey = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1ReferralPopupsPartnerKey>>, TError,{partnerKey: string | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1ReferralPopupsPartnerKey>>,
        TError,
        {partnerKey: string | null},
        TContext
      > => {
      return useMutation(getDeleteApiV1ReferralPopupsPartnerKeyMutationOptions(options), queryClient);
    }
    export const getApiV1ReferralPopupsPartnerKey = (
    partnerKey: string | null,
 signal?: AbortSignal
) => {


      return apiClient<GetReferralPopupByPartnerKeyResponse | null>(
      {url: `/api/v1/referral-popups/${partnerKey}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1ReferralPopupsPartnerKeyQueryKey = (partnerKey: string | null,) => {
    return [
    `/api/v1/referral-popups/${partnerKey}`
    ] as const;
    }


export const getGetApiV1ReferralPopupsPartnerKeyQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError = ProblemDetails | null>(partnerKey: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ReferralPopupsPartnerKeyQueryKey(partnerKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>> = ({ signal }) => getApiV1ReferralPopupsPartnerKey(partnerKey, signal);





   return  { queryKey, queryFn, enabled: partnerKey !== null && partnerKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ReferralPopupsPartnerKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>>
export type GetApiV1ReferralPopupsPartnerKeyQueryError = ProblemDetails | null


export function useGetApiV1ReferralPopupsPartnerKey<TData = Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError = ProblemDetails | null>(
 partnerKey: string | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ReferralPopupsPartnerKey<TData = Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError = ProblemDetails | null>(
 partnerKey: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ReferralPopupsPartnerKey<TData = Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError = ProblemDetails | null>(
 partnerKey: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ReferralPopupsPartnerKey<TData = Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError = ProblemDetails | null>(
 partnerKey: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ReferralPopupsPartnerKey>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ReferralPopupsPartnerKeyQueryOptions(partnerKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






